const React = require("react");
const T = require("prop-types");
const RaisedButton = require("material-ui/RaisedButton").default;
const NavLink = require("react-router-dom").NavLink;
const Classes = require("./styles.scss");
const Paper = require("material-ui/Paper").default;

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

module.exports = class HomeView extends React.Component {
    static propTypes = {
        isAuthenticated: T.bool.isRequired
    };

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    renderButton = () => {
        return (
            <RaisedButton
                className={Classes.testTest}
                label="Try a Free Preview"
                containerElement={<NavLink to="/create-account" />}
                labelStyle={{
                    textTransform: "inherit"
                }}
            />
        );
    };

    renderAuthenticatedButton = () => {
        return (
            <RaisedButton
                className={Classes.testTest}
                label="Try a Free Preview"
                containerElement={<NavLink to="/instructions" />}
                labelStyle={{
                    textTransform: "inherit"
                }}
            />
        );
    };

    render() {
        const { isAuthenticated } = this.props;

        const renderedButton = isAuthenticated
            ? this.renderAuthenticatedButton()
            : this.renderButton();
        const iconLink = isAuthenticated ? "/instructions" : "/create-account";

        return (
            <div>
                <div className={Classes.homepageHeader}>
                    <div className={Classes.headerTextContainer}>
                        <div className={Classes.headerText}>
                            <h1>
                                Fashion sketch templates of <em>your</em> body
                            </h1>
                            {renderedButton}
                        </div>
                    </div>
                    <div className={Classes.headerImgContainer} />
                </div>
                <div className={Classes.homepageContainer}>
                    <Paper style={internals.paperStyle}>
                        <h2>
                            Be your own fashion designer — On a model of your
                            own body.
                        </h2>
                        <p>
                            With the MyBodyModel™ web app you can create your
                            own personal fashion croquis (sketching templates)
                            made to your measurements. So you can draw your
                            dream wardrobe on an outline of your own body!
                        </p>
                    </Paper>
                    <Paper style={internals.paperStyle}>
                        <h2>Here&rsquo;s How It Works</h2>
                        <div className={Classes.howWorksContainer}>
                            <div className={Classes.howWorksGrid}>
                                <NavLink to={iconLink}>
                                    <div
                                        className={`${Classes.exampleBlock} ${Classes.block1}`}
                                    />
                                </NavLink>
                                <p>
                                    Enter your
                                    <br />
                                    measurements
                                </p>
                            </div>
                            <div className={Classes.howWorksGrid}>
                                <NavLink to={iconLink}>
                                    <div
                                        className={`${Classes.exampleBlock} ${Classes.block2}`}
                                    />
                                </NavLink>
                                <p>
                                    Get a free preview of
                                    <br />
                                    your body model
                                </p>
                            </div>
                            <div className={Classes.howWorksGrid}>
                                <NavLink to={iconLink}>
                                    <div
                                        className={`${Classes.exampleBlock} ${Classes.block3}`}
                                    />
                                </NavLink>
                                <p>
                                    If you like it, pay
                                    <br />
                                    to download
                                </p>
                            </div>
                        </div>
                    </Paper>
                    <Paper style={internals.paperStyle}>
                        <p>
                            Every download package includes your customized body
                            model in JPG and PDF formats. Print your PDF and
                            sketch on paper, or import your JPG into your
                            favorite illustration software to sketch digitally.
                        </p>
                        <h2>Ready To Get Started?</h2>
                        {renderedButton}
                    </Paper>
                </div>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/home/components/HomeView.js